import script from "./RoomCarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomCarouselComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomCarouselComponent.vue?vue&type=style&index=0&id=6635729c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6635729c"]])

export default __exports__